export default __webpack_public_path__ + "static/media/loading.43b41248.gif";